import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React, { useState, useEffect } from 'react';
import DefaultTheme from './theme';
export var FormElementTheme = DefaultTheme;
/*::
import type { Node } from 'react';

export type FormElementThemeType = {|
  Main: * => Node;
  Label: * => Node;
  GroupLabel: * => Node;
  Required: * => Node;
  Placeholder: * => Node;
  CaptionsContainer: * => Node;
  Hint: * => Node;
  Error: * => Node;
|}

export type Props = {|
  placeholder?: string;
  label?: string,
  hint?: string,
  error?: string,
  disabled?: boolean,
  required?: boolean,
  forceLabel?: boolean,

  children: Node,

  // To keep track of label and placeholder status
  hasValue?: boolean;
  onFocus?: (e: FocusEvent) => void;
  onBlur?: (e: FocusEvent) => void;

  // Accessibility
  htmlFor?: string;

  theme?: FormElementThemeType;
  "data-test"?: string,
  rest?: any,
|}
*/

var FormElement = function FormElement(_ref
/*: Props */
, ref) {
  var _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$hint = _ref.hint,
      hint = _ref$hint === void 0 ? '' : _ref$hint,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? '' : _ref$error,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$forceLabel = _ref.forceLabel,
      forceLabel = _ref$forceLabel === void 0 ? false : _ref$forceLabel,
      _ref$hasValue = _ref.hasValue,
      hasValue = _ref$hasValue === void 0 ? false : _ref$hasValue,
      children = _ref.children,
      _ref$htmlFor = _ref.htmlFor,
      htmlFor = _ref$htmlFor === void 0 ? '' : _ref$htmlFor,
      _ref$onFocus = _ref.onFocus,
      _onFocus = _ref$onFocus === void 0 ? function () {
    return undefined;
  } : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      _onBlur = _ref$onBlur === void 0 ? function () {
    return undefined;
  } : _ref$onBlur,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["placeholder", "label", "hint", "error", "disabled", "required", "forceLabel", "hasValue", "children", "htmlFor", "onFocus", "onBlur", "theme"]);

  var _useState = useState({
    focused: false
  }),
      focused = _useState[0].focused,
      setFocused = _useState[1];
  /**
   * Because inputs have debounce, we can't rely on hasValue
   * to show/hide placeholder. Hence this internal state var.
   * Warning: placeholder also depends on 'placeholder', 'focused', etc.
   */


  var _useState2 = useState({
    showPlaceholder: true
  }),
      showPlaceholder = _useState2[0].showPlaceholder,
      setShowPlaceholder = _useState2[1];

  useEffect(function () {
    if (!hasValue) {
      setShowPlaceholder({
        showPlaceholder: true
      });
    }
  }, [hasValue]);
  var isRadioOrCheckbox = false;
  React.Children.forEach(children, function (child) {
    if (child.type.displayName === 'RadioButton' || child.type.displayName === 'Checkbox') {
      isRadioOrCheckbox = true;
    }
  });
  var isDateInput = false;
  React.Children.forEach(children, function (child) {
    if (child.type.displayName === 'DateInput') {
      isDateInput = true;
    }
  });

  if (isDateInput) {
    /* Date picker alwas has it's own placeholder or value */
    forceLabel = true; // eslint-disable-line

    placeholder = ''; // eslint-disable-line
  }

  return /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    ref: ref
    /*: any */

    /* until StyledComponent typing is fixed */
    ,
    onKeyDown: function onKeyDown() {
      setShowPlaceholder({
        showPlaceholder: false
      });
    }
  }, rest), label && !isRadioOrCheckbox ? /*#__PURE__*/React.createElement(theme.Label, {
    "data-test": "form-element-label",
    htmlFor: htmlFor,
    focused: forceLabel || focused || error !== '' || hasValue,
    error: error !== ''
  }, label, required ? /*#__PURE__*/React.createElement(theme.Required, null, "*") : null) : null, label && isRadioOrCheckbox ? /*#__PURE__*/React.createElement(theme.GroupLabel, {
    "data-test": "form-element-group-label",
    htmlFor: htmlFor,
    focused: forceLabel || focused || error !== '' || hasValue,
    error: error !== ''
  }, label, required ? /*#__PURE__*/React.createElement(theme.Required, null, "*") : null) : null, placeholder && !hasValue && (focused || forceLabel) && showPlaceholder ? /*#__PURE__*/React.createElement(theme.Placeholder, {
    value: placeholder
  }) : null, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      disabled: disabled,
      onFocus: function onFocus(e) {
        setFocused({
          focused: true
        });

        _onFocus(e);
      },
      onBlur: function onBlur(e) {
        setFocused({
          focused: false
        });

        _onBlur(e);
      } // error, // disabled it because there are cases when you won't
      // need this behaviour in the phone-input there was a case
      // when error on the form element didn't necessarily menat that
      // we want to highlight the whole component as in error state.
      // So basically to sum up its up do developer now to handle this

    });
  }), (error || hint) && /*#__PURE__*/React.createElement(theme.CaptionsContainer, null, error && /*#__PURE__*/React.createElement(theme.Error, {
    "data-test": "form-element-error"
  }, error), hint && /*#__PURE__*/React.createElement(theme.Hint, {
    "data-test": "form-element-hint"
  }, hint)));
};

export default /*#__PURE__*/React.forwardRef
/*:: <Props, HTMLDivElement> */
(FormElement);